import { render } from "./baseSetup.vue?vue&type=template&id=72c166de"
import script from "./baseSetup.vue?vue&type=script&lang=js"
export * from "./baseSetup.vue?vue&type=script&lang=js"

import "./baseSetup.vue?vue&type=style&index=0&id=72c166de&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__